<template>
  <div
    :class="['boredice_back', { 'boredice_back_m': !isPC }]"
    id="boredice_back"
    :style="{ '--boxHeight': boxHeight + 'px' }"
  >
    <div :class="['mobile-show', boxHeight ? 'box_2' : 'box']" id="box"></div>
    <div class="boredice_text">
      <p class="Boredice">Bruce Hsia</p>
      <div class="describe">
        <div class="mobile-hide">
          Bruce Hsia is a full-stack designer, serial entrepreneur, and builder at the
          intersection of digital creativity and physical production.
        </div>
        <br />
        <div class="mobile-hide">
          In 2018, he founded
          <a
            class="link"
            href="https://ice.design"
            target="_blank"
            rel="noopener noreferrer"
            >ice.design</a
          >, a design studio that has partnered with global brands such as Audi,
          Pandora, Kumamon, Alibaba Group, Tencent, Joe Tsai Foundation, BCG,
          Bilibili, Linefriends, OKJ, SlowMist, NXT, UneMeta etc. — all driven
          by one belief: Great Design Makes Greats.
        </div>
        <div class="mobile-show">
          is a full-stack designer, serial entrepreneur, and builder at the
          intersection of digital creativity and physical production.
          <br />
          <br />
          In 2018, he founded
          <a
            class="link"
            href="https://ice.design"
            target="_blank"
            rel="noopener noreferrer"
            >ice.design</a
          >
          , a design studio that has partnered with global brands such as Audi,
          Pandora, Kumamon, Alibaba Group, Tencent<span>{{
            show
              ? ", Joe Tsai Foundation, BCG, Bilibili, Linefriends, OKJ, SlowMist, NXT, UneMeta etc. — all driven by one belief: Great Design Makes Greats."
              : "..."
          }}</span>
        </div>

        <div :class="['describe-d', { show }]">
          <br />
          Driven by his love for anime &amp; collectible culture, Bruce launched
          <a
            class="link"
            href="https://tokenpresent.com"
            target="_blank"
            rel="noopener noreferrer"
            >TokenPresent</a
          >
          in 2023 — a full-stack product supply chain company covering R&amp;D →
          Design → Sampling → Production → Packaging → Shipping. In addition,
          TokenPresent embed chips into products, enabling "Tap to own" — a
          trifecta of authenticity verification, digital identity, and exclusive
          interactive experience, giving every product a digital soul.
          <br />
          <br />
          Bruce created
          <a class="link" :href="url" target="_blank" rel="noopener noreferrer"
            >BeanStarters</a
          >
          (2023, formerly known as FrameBeans) and
          <a
            class="link"
            href="https://Martzuki.com"
            target="_blank"
            rel="noopener noreferrer"
            >Martzuki</a
          >
          (2024) — a built-in crowdfunding engine that helps creators to
          validate demand before production.
          <br />
          <br />
          All of these — live under the roof of
          <a
            class="link"
            href="https://IProtocol.com"
            target="_blank"
            rel="noopener noreferrer"
            >IProtocol Labs</a
          >. His lifelong dream — a place dedicated to turning virtual and
          creativity into real-world artifacts. His mission is to build a world
          leading infrastructure that connects on-chain IP management, flexible
          supply chain, and physical product distribution — unlocking new
          possibilities for creators worldwide.
        </div>
      </div>
      <img
        src="https://ice-design.s3.ap-southeast-1.amazonaws.com/boredice/bg.gif"
        alt="bg"
        class="ice"
      />
      <div class="mobile-show see" @click="changeSee">
        <img
          src="@/assets/icon.png"
          :class="['icon', { 'icon_2': show }]"
          alt=""
        />
      </div>
    </div>
    <div :class="['boredice_item', { 'boredice_item_2': show }]">
      <div class="boredice_item_box">
        <a
          v-for="(item, idx) in list"
          :key="idx"
          :class="['item', item.class]"
          :href="item.href"
          :target="item.disabled ? '_self' : '_blank'"
        >
          <div class="left">
            <p class="name">{{ item.name }}</p>
            <p v-html="item.des" class="des mobile-hide"></p>
            <div class="mobile mobile-show">
              <p v-html="item.des" class="des"></p>
            </div>
          </div>
          <img :src="item.img" alt="" class="img" />
        </a>
      </div>
      <p class="copyright">{{ currentYear }} © brucehsia.com</p>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery';
import { mapGetters } from 'vuex'
import emojiCat from '@/assets/boredice/cat.png'
import emojiIp from '@/assets/boredice/ip-2.png'
import ip from '@/assets/boredice/ip.png'
import x from '@/assets/boredice/x.png'
import tg from '@/assets/boredice/tg.png'
import mzk from '@/assets/boredice/mzk.png'
import be from '@/assets/boredice/be.png'
import machine from '@/assets/boredice/machine.png'
import tkp from '@/assets/boredice/tkp.png'
import coming from '@/assets/boredice/coming.png'
import emoji_7 from '@/assets/boredice/emoji_7.png'

const beanStartersUrl = 'https://www.BeanStarters.com' // 先 https://framebeans.com 后面会改为 https://BeanStarters.com
const snowFallParticleYRangeKey = 'particleY_Range'
const snowFallParticleXRangeKey = 'particleX_Range'
const snowFallWindWeightKey = 'wind_weight'

export default {
  data () {
    return {
      list: [
        {
          name: 'IProtocol Labs',
          des: `IP is the future. <img src="${emojiIp}" alt="emoji_5" class="emoji">`,
          img: ip,
          href: 'https://iprotocol.com',
          class: ''
        },
        {
          name: 'ice.design',
          des: `Great Design Makes Greats. <img src="${emojiCat}" alt="emoji_1" class="emoji">`,
          img: 'https://ice-design.s3.ap-southeast-1.amazonaws.com/boredice/1s.gif',
          href: 'https://ice.design',
          class: 'gif'
        },
        {
          name: 'TokenPresent',
          des: `Make it. Chip it. Ship it. <img src="${machine}" alt="emoji_4" class="emoji">`,
          img: tkp,
          href: 'https://tokenpresent.com',
          class: ''
        },
        {
          name: 'Martzuki',
          des: 'Your gateway to the Garden. <img src="https://ice-design.s3.ap-southeast-1.amazonaws.com/boredice/emoji_3.png" alt="emoji_3" class="emoji">',
          img: mzk,
          href: 'https://www.martzuki.com',
          class: ''
        },
        {
          name: 'BeanStarters',
          des: 'Ready to take the real bean? <img src="https://ice-design.s3.ap-southeast-1.amazonaws.com/boredice/emoji_4.png" alt="emoji_4" class="emoji">',
          img: be,
          href: beanStartersUrl,
          class: 'be'
        },
        {
          name: '???????',
          des: 'coming soon... 🚀',
          img: coming,
          href: 'javascript:void(0)',
          class: '',
          disabled: true // 禁用点击事件
        },
        {
          name: 'Mail',
          des: `brucehsia@iprotocol.com <img src="${emoji_7}" alt="emoji" class="emoji">`, //  You won‘t regret it.
          img: x,
          href: 'mailto:brucehsia@iprotocol.com',
          class: ''
        },
        {
          name: 'Telegram',
          des: 'Design · Production · Inquiries · Collab <img src="https://ice-design.s3.ap-southeast-1.amazonaws.com/boredice/emoji_6.png" alt="emoji_6" class="emoji">',
          img: tg,
          href: 'https://t.me/boredice',
          class: ''
        }
      ],
      show: false,
      boxHeight: 0,
      url: beanStartersUrl
    }
  },
  computed: {
    ...mapGetters(['isPC']),
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    changeSee () {
      const box = document.getElementById('box')
      this.boxHeight = box.offsetHeight || box.clientHeight || 0
      this.$nextTick(() => {
        this.show = !this.show
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.$.snowFall({
        // 创建粒子数量，密度
        particleNo: this.isPC ? 150 : 50,
        // 粒子下拉速度
        particleSpeed: 30,
        // 粒子在垂直（Y轴）方向运动范围
        [snowFallParticleYRangeKey]: 1300,
        // 粒子在垂直（X轴）方向运动范围
        [snowFallParticleXRangeKey]: 1000,
        // 是否绑定鼠标事件
        bindMouse: true,
        // 相机离Z轴原点距离
        zIndex: 600,
        // 摄像机视野角度
        angle: 55,
        [snowFallWindWeightKey]: 0
      })
    })
  }
}
</script>

<style lang="less">
/* 定义图标的上下浮动动画 */
@keyframes float {
  0% {
    transform: translateY(0) scale(1.4);
  }
  50% {
    transform: translateY(-10px) scale(1.4);
  }
  100% {
    transform: translateY(0) scale(1.4);
  }
}

.boredice_back {
  font-family: "Poppins-Medium";
  min-height: 100%;
  position: relative;
  background: #000;
  padding: 80px 80px 24px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .boredice_text {
    position: relative;
    flex: 1;
    .ice {
      position: absolute;
      right: 0;
      // top: -98px;
      bottom: 0;
      width: 548px;
    }
    .Boredice {
      font-size: 32px;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 24px;
      font-family: "Poppins-Bold";
    }
    .describe {
      font-size: 14px;
      font-weight: 400;
      width: 52%;
      position: relative;
      z-index: 2;
      strong {
        font-family: "Poppins-Bold";
      }
      .link {
        color: #00a1ff;
        text-decoration: revert !important;
        text-decoration: underline;
      }
    }
  }
  .boredice_item {
    margin: 48px 0 0;
    .boredice_item_box {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%; /*有几列，每列有多大*/
      grid-gap: 24px; /*上下左右间隔*/
      .item {
        border-radius: 16px;
        background: #272727;
        backdrop-filter: blur(4px);
        padding: 0 0 0 24px;
        width: 100%;
        height: 128px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        color: #fff;
        &:hover {
          .img {
            transform: scale(1.4);
            animation: float 1.5s infinite 0.3s;
          }
        }
        .left {
          .name {
            font-size: 24px;
            line-height: 24px;
            font-family: "Poppins-Bold";
            margin: 24px 0 12px;
          }
          .des {
            font-size: 14px;
            font-weight: 400;
            line-height: 140%;
            padding-bottom: 24px;
            .emoji {
              display: inline-block;
              width: 14px;
              vertical-align: middle;
            }
          }
          .icon {
            display: none;
          }
        }
        .img {
          transition: all 0.3s ease;
          width: 128px;
          flex-shrink: 0;
        }
      }
      .be {
        padding: 0 20px 0 24px;
        .img {
          width: 128px;
        }
      }
      .pointer-events {
        pointer-events: none;
      }
      .gif {
        padding: 0 20px 0 24px;
        &:hover {
          .img {
            transform: scale(1);
            animation: none;
          }
        }
        .img {
          width: 120px;
          height: 45px;
        }
      }
      .Martzuki {
        padding: 0 0 0 24px;
      }
    }
    .copyright {
      font-size: 12px;
      font-weight: 400;
      opacity: 0.6;
      margin: 24px 0 0;
    }
  }
}

@media (max-height: 1000px) {
  .boredice_back {
    .boredice_text {
      .ice {
        // top: -28px;
        width: 505px;
      }
    }
  }
}

@media (max-height: 900px) {
  .boredice_back {
    .boredice_text {
      .ice {
        // top: -68px;
        width: 505px;
      }
    }
  }
}

// 在
@media only screen and (max-width: 1320px) {
  .boredice_back {
    .boredice_text {
      .describe {
        width: 45%;
      }
      .ice {
        width: 505px;
        bottom: 0;
      }
    }
    .boredice_item {
      .boredice_item_box {
        grid-template-columns: 32% 32% 32%; /*有几列，每列有多大*/
        grid-gap: 24px; /*上下左右间隔*/
        .item .img {
          width: 96px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1100px) {
  .boredice_back {
    .boredice_text {
      .Boredice {
        position: relative;
        z-index: 2;
      }
      .describe {
        width: 40%;
        position: relative;
        z-index: 2;
      }
      .ice {
        width: 548px;
      }
    }
  }
}

/* 平板样式（屏幕宽度在 768px 到 1023px 之间） */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .boredice_back {
    padding: 50px 50px 20px;
    .boredice_text {
      .ice {
        width: 465px;
      }
    }
    .boredice_item {
      .boredice_item_box {
        grid-template-columns: 48% 48%; /*有几列，每列有多大*/
        grid-gap: 24px; /*上下左右间隔*/
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .boredice_back {
    padding: 0 16px 40px;
    overflow: auto;
    height: 100%;
    .box {
      // height: calc(100% - 30%);
      // flex-shrink: 0;
      flex: 1;
    }
    .box_2 {
      height: var(--boxHeight);
      flex-shrink: 0;
    }
    .boredice_text {
      flex: none;
      .Boredice {
        font-size: 24px;
        margin-bottom: 12px;
      }
      .describe {
        width: 100%;
        font-size: 14px;
        .describe-d {
          display: none;
        }
        .show {
          display: block;
        }
      }
      .ice {
        width: 170px;
        top: -140px;
      }
      .see {
        margin-top: 12px;
        .icon {
          width: 16px;
          height: 16px;
          margin: 0 auto;
          display: block;
          transition: all 0.3s;
        }
        .icon_2 {
          transform: rotate(180deg);
        }
      }
    }
    .boredice_item {
      display: none;
      .boredice_item_box {
        grid-template-columns: 100%; /*有几列，每列有多大*/
        grid-gap: 16px; /*上下左右间隔*/
        .item {
          padding: 0 0 0 16px;
          &:hover {
            .img {
              transform: none;
              animation: none;
            }
          }
          .left {
            .name {
              font-size: 24px;
              line-height: 24px;
            }
            .des {
              font-size: 14px;
              transition: all 0.3s ease;
            }
            .mobile {
              display: flex;
              .des-2 {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /* autoprefixer: ignore next */
                -webkit-box-orient: vertical;
              }
            }
            .imgBox {
              width: 20px;
              height: 20px;
              flex-shrink: 0;
              .icon {
                display: inline-block;
                width: 16px;
                height: 16px;
                transition: all 0.3s ease;
              }
              .icon-2 {
                transform: rotate(180deg);
              }
            }
          }
        }

        .gif {
          .img {
            margin-right: 16px;
            width: 80px;
            height: 30px;
          }
        }
        .aGiftime {
          padding: 0 10px 0 16px;
        }
      }
      // /* 第3个 → 排最后 */
      // .boredice_item_box > *:nth-child(3) { order: 10; }
      // /* 第4个 → 排倒数第二 */
      // .boredice_item_box > *:nth-child(4) { order: 9; }
      .copyright {
        margin: 16px 0 0;
      }
    }
    .boredice_item_2 {
      display: block;
    }
  }
}
.container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
}
</style>
